/**
 * Created by slava on 01.08.17.
 */

const MultiColorCell = function (x, y) {
    BaseCell.call(this, x, y);

    this.movable = true;
    this.explodeOnGameFinish = true;

    this.putInPoolAvailable = true;
    this.fallThroughBarrier = true;
};

MultiColorCell.prototype = Object.create(BaseCell.prototype);
MultiColorCell.prototype.constructor = MultiColorCell;

MultiColorCell.prototype.load = function () {
    // do nothing
};

MultiColorCell.prototype.save = function () {
    return MultiColorCell.CODES;
};

MultiColorCell.prototype.canMoveWith = function (neighbor) {
    return neighbor.findComponent(ColorComponent) || (neighbor instanceof MultiColorCell);
};

MultiColorCell.prototype.updateMoveHover = function (value) {
    const cells = Game.currentGame.field.cells;
    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            if (cells[i][j] && cells[i][j] !== this) {
                if ((this.currentHoverColor === -1 && cells[i][j].hurtable) || cells[i][j].getColor() === this.currentHoverColor) {
                    cells[i][j].hover(value);
                }
            }
        }
    }
};

MultiColorCell.prototype.removeMoveHover = function () {
    if (this.currentHoverColor) {
        this.updateMoveHover(false);
        this.currentHoverColor = undefined;
    }
};

MultiColorCell.prototype.addMoveHover = function () {
    if (this.currentHoverColor) {
        this.updateMoveHover(true);
    }
};

MultiColorCell.prototype.onRemoveSelection = function () {
    this.removeMoveHover();
};

MultiColorCell.prototype.onMouseMove = function (cell) {
    let cellColor = undefined;
    if (cell && cell.hurtable && Math.abs(cell.x - this.x) + Math.abs(cell.y - this.y) === 1 && cell.movable) {
        if (cell instanceof MultiColorCell) {
            cellColor = -1;
        } else {
            const colorComponent = cell.findComponent(ColorComponent);
            cellColor = colorComponent && colorComponent.color;
        }
    }

    if (this.currentHoverColor === cellColor) {
        return;
    }

    this.removeMoveHover();
    this.currentHoverColor = cellColor;
    this.addMoveHover();
};

MultiColorCell.prototype.getViewClass = function () {
    return MultiColorCellView;
};

MultiColorCell.prototype.explodeDuration = function () {
    return 0.5;
};

MultiColorCell.prototype.chooseRandomColor = function () {
    const cells = Game.currentGame.field.cells;

    const colors = [];
    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            const colorComponent = cells[i][j] && cells[i][j].findComponent(ColorComponent);
            if (colorComponent && colorComponent.color) {
                colors.push(colorComponent.color);
            }
        }
    }

    if (colors.length === 0) {
        return undefined;
    }

    return PseudoRandom.GET().choose(colors);
};

MultiColorCell.prototype.chooseNumerousColor = function () {
    const cells = Game.currentGame.field.cells;

    let numerousColor;
    let max = 0;

    const colors = {};
    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            const cell = cells[i][j];
            if (!cell) {
                continue;
            }

            const colorComponent = cell.findComponent(ColorComponent);
            if (colorComponent && colorComponent.color) {
                if (!colors[colorComponent.color]) {
                    colors[colorComponent.color] = 0;
                }

                colors[colorComponent.color]++;

                if (colors[colorComponent.color] > max) {
                    max = colors[colorComponent.color];
                    numerousColor = colorComponent.color;
                }
            }
        }
    }

    return numerousColor;
};

MultiColorCell.prototype.onExplode = function () {
    if (this.hurtByMulticolor) {
        return;
    }

    BaseCell.prototype.onExplode.call(this);

    if (this.chosenColor === undefined && !this.chosenComboType) {
        this.chosenColor = this.chooseRandomColor();
    }

    const toExplode = [];
    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            const cell = Game.currentGame.field.cells[i][j];

            if (!(cell && cell.alive && cell.lives > 0)) {
                continue;
            }

            const comboComponent = cell.findComponent(ComboComponent);
            const comboType = comboComponent && comboComponent.getType();
            if (this.chosenColor && cell.getColor() === this.chosenColor || this.chosenColor === MultiColorCell.COLOR_ALL || this.chosenComboType && comboType === this.chosenComboType) {
                toExplode.push(cell);
            }
        }
    }

    toExplode.forEach((cell) => {
        cell.prepareForBurn();
    });

    cleverapps.eventBus.trigger("taskEvent", "USE_MULTI_COLOR_CELL");
    cleverapps.eventBus.trigger("use_multicolor_cell");

    if (Game.currentGame.lightingRushMission && toExplode.length) {
        const view = this.onGetView();
        if (view && view.getParent()) {
            const position = BaseCellView.alignInTheGrid(this.x, this.y);
            position.y += cleverapps.styles.BaseCellView.CELL_SIZE_PX * 0.8;
            MissionCollectDelta.show(Mission.TYPE_LIGHTNING_RUSH, toExplode.length, view.getParent().convertToWorldSpace(position));
        }
        cleverapps.eventBus.trigger("collectMark", toExplode.length);
    }

    const toAnimate = [];
    Array.prototype.push.apply(toAnimate, toExplode);
    cleverapps.shuffleInPlace(toAnimate).forEach((cell) => {
        cell.animate(BaseCell.ANIMATION_MULTI_COLOR_SELECT, { multiColorCell: this });
    });

    const isTwoPiesCase = (this.chosenColor === MultiColorCell.COLOR_ALL);

    toExplode.forEach((cell, id) => {
        if (!isTwoPiesCase) {
            cell.boomNeighbors(1);
        } else if (cell instanceof MultiColorCell) {
            cell.hurtByMulticolor = true; // other pies should not explode and hurt cells
        }
        cell.hurt({
            id,
            groupSize: toExplode.length
        });
        RugTile.hurtViaCombo(this, cell);
    });
};

MultiColorCell.COLOR_ALL = -1;
MultiColorCell.MAX_SPECIAL_CREATE = 5;

MultiColorCell.prototype.crazyActionDuplicateCombos = function (neighbor, callback) {
    callback = callback || function () {};

    this.chosenColor = neighbor.getColor();

    let targetColor;
    if (!this.chosenColor) {
        targetColor = this.chooseNumerousColor();
        this.chosenComboType = neighbor.findComponent(ComboComponent).getType();
    }

    let variants = [];
    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            const cell = Game.currentGame.field.cells[i][j];
            if (cell && cell.canDelete() && (cell.getColor() === this.chosenColor || targetColor && cell.getColor() === targetColor)) {
                variants.push(cell);
            }
        }
    }

    if (this.chosenComboType) {
        variants = cleverapps.shuffleInPlace(variants);
    } else if (variants.length > MultiColorCell.MAX_SPECIAL_CREATE) {
        variants = cleverapps.shuffleInPlace(variants).slice(0, MultiColorCell.MAX_SPECIAL_CREATE);
    }
    variants.forEach((cell) => {
        const specialCell = ComboComponent.Create(cell, {
            neighbor,
            randomDir: true
        });
        cell.delete();
        Game.currentGame.field.addCell(specialCell);
        specialCell.animate(BaseCell.ANIMATION_CREATE);
    });

    this.explode({
        callback
    });
};

MultiColorCell.prototype.crazyActionSimple = function (neighbor) {
    this.chosenColor = neighbor.getColor();
    this.explode();
};

MultiColorCell.IsAvailable = function () {
    if (cleverapps.gameModes.multiColorCellDisabled) {
        return false;
    }

    return cleverapps.user.checkAvailable(cleverapps.config.availables.MULTI_COLOR_CELL);
};
